export default (text) => {
    if (!text)
        return 'Not found'

    const newText = text

    newText.content.forEach((item) => {
        if (item.type === 'paragraph')
            item.type = 'text'
    })

    return renderRichText(newText)
}
